import React from "react";
import "../../Css/Appintroduction.css";

function Appintroduction() {
  const data = [
    {
      title: "GKA APP INTRODUCTION",
      introduction:
        "GKA is very thrilled to launch this 'GKA-APP' to you. It is wonderful & exciting, the new modern era communication platform for our community. Finally, our dream has come true and our efforts paid off.",
      vision:
        "It was Harish Doolabh's vision and thoughts, persistent push, persuasion to leading and active community volunteers. All that has produced this final shape of GKA-APP.",
      features: [
        " Members listing has the similar format as your phone address book. We are also in the process to add our foreign community members.",
        "Able to search any friend & relative from the community within listed countries.",
        "You are able to upload one individual & one family picture. You will be also able to edit these pictures at any time.",
        "Option to call, text or video call (using Skype or WhatsApp) to your contacts at no cost thru your internet connection.",
        "You will be able to edit your personal information (e.g. changes of address, family detail, phone numbers etc.) on your own.",
        "Ability to upload any announcements of family events like marriage, birth and death within the community instead of depending on any platform such as FACEBOOK, Email.",
        "Access to community magazines like Hitechchhoo, Manav Seva and Mochi Times.",
      ],
      history: {
        past_directories:
          "Since GKA's existence from 1990, we published 4 print versions and 2 digital versions of community directories. In the process of preparation of all those directories, many dedicated volunteers spent innumerable hours and spent lots of money. There were many difficulties to obtain updated and accurate member's family information. Though it was lot of work, but we did with spirit of our community volunteers.",
        modern_approach:
          "By introducing this APP, we hope to eliminate repetitive task traditional directories demand. Also we will be able to expand our reach beyond the boundaries of North America. Not only that, we also will be able to locate our lost community friends and families.",
      },
      future_plans:
        "We do intend to use this app for Matrimonial purposes at the later stage along with our other community-related activities such as Convention & Newspapers.",
      community_expectation:
        "GKA hopes that this modern means of communication will be widely used by our community as it is user-friendly and live updated information from the community.",
      vote_of_thanks:
        "Finally, GKA would like to extend heartily thanks to Ketan Chauhan, Krishna Software from Kosamba, India, the designer of this APP and our tech-savvy volunteers for their monetary and time behind this project which now came to final fruition. Last but not least, our heartily thanks to those who have helped us directly or indirectly.",
    },
  ];

  return (
    <div className="container">
      <div className="content-box">
        {data.map((item, index) => (
          <div key={index}>
            <h1>{item.title}</h1>
            <p>{item.introduction}</p>
            <p>{item.vision}</p>
            <h2>Key Features:</h2>
            <ul>
              {item.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
            <h2>History:</h2>
            <p>
              <strong>Past Directories:</strong> {item.history.past_directories}
            </p>
            <p>
              <strong>Modern Approach:</strong> {item.history.modern_approach}
            </p>
            <h2>Future Plans:</h2>
            <p>{item.future_plans}</p>
            <h2>Community Expectation:</h2>
            <p>{item.community_expectation}</p>
            <h2>Vote of Thanks:</h2>
            <p>{item.vote_of_thanks}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Appintroduction;
